import React from "react";
import { Button } from "@material-ui/core";
import { Helmet } from "react-helmet";

import Header from "../sections/Header";
import LineSeparator from "../sections/LineSeparator";
import BlockHeading from "../sections/BlockHeading";
import GreenBlockSection from "../sections/GreenBlockSection";
import CoverFlowGallery from "../sections/CoverFlowGallery";

const styles = {
  enquiryButton: {
    marginTop: 10,
    width: 260,
    maxWidth: "100%",
    textTransform: "none",
  },
};

const GALLERY_IMAGES = [
  { src: "/images/latitudes/latitudes-01.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-02.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-03.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-04.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-05.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-06.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-07.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-08.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-09.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-10.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-11.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-12.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-13.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-14.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-15.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-16.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-17.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-18.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-19.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-20.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
  { src: "/images/latitudes/latitudes-21.jpg", alt: "Latitudes Centre for the Arts at Shepstone Gardens" },
];

const LatitudesCentre = () => {
  return (
    <div>
      <Helmet>
        <title>Latitudes Centre for the Arts | The Shepstone Experience</title>
        <meta
          name={"description"}
          content={"A distinguished art gallery venue for cultural events, conferences and bespoke private functions, set within the beautiful Shepstone Gardens, Johannesburg."}
        ></meta>
      </Helmet>

      <Header
        bgImg={"/images/latitudes/latitudes-01.jpg"}
        headText={"LATITUDES CENTRE FOR THE ARTS"}
      />

      <LineSeparator noLine />
      <LineSeparator noLine />

      <GreenBlockSection
        headText={"Latitudes Centre for the Arts"}
        subHeadText={"Welcome to"}
      >
        <div className={"three-columns"}>
          <p className={"venue-intro-text"}>
            Latitudes Centre for the Arts is a distinguished venue for cultural events and conferences, located within the exquisite Shepstone Gardens, Johannesburg. Nestled among winding pathways, overgrown stone archways, a labyrinth of wild, terraced gardens, and sweeping city views, the Centre offers a truly unique setting for conferences and events.
          </p>
          <p className={"venue-intro-text"}>
            Alongside its year-round programme of exhibitions, talks and cultural events, LCA is available to hire for private functions, launches, dinners, celebrations, brand activations, talks and other bespoke events. The gallery provides a unique backdrop for occasions that call for something beyond a traditional event venue, combining contemporary art, considered architecture and the natural beauty of Shepstone Gardens.
          </p>
          <p className={"venue-intro-text"}>
            Whether you're planning a wedding celebration, intimate dinner, product launch, corporate gathering or private event, the LCA space can be tailored to suit your occasion.
          </p>
        </div>
      </GreenBlockSection>

      <LineSeparator noLine />
      <LineSeparator noLine />
      <LineSeparator />
      <BlockHeading
        headText={"A space unlike any other"}
        noBorder
      />

      <CoverFlowGallery
        images={GALLERY_IMAGES}
        noOvButton
      />

      <LineSeparator />
      <BlockHeading
        headText={"Interested in hosting your event at Latitudes Centre for the Arts?"}
        noBorder
      />
      <p
        className={"venue-intro-text"}
        style={{ textAlign: "center" }}
      >
        For venue hire enquiries, please get in touch with the Latitudes team.
      </p>
      <div style={{ textAlign: "center" }}>
        <Button
          href={"mailto:info@latitudes.online"}
          variant={"contained"}
          color={"secondary"}
          style={styles.enquiryButton}
        >
          info@latitudes.online
        </Button>
      </div>

      <LineSeparator noLine />
    </div>
  );
};

export default LatitudesCentre;
